// extracted by mini-css-extract-plugin
module.exports = {"text":"D-zRkPOhSBeSfyUGZo6KE","container":"_2ZE256IPaNGBv-mZX_wxqU primaryBackgroundColor"};